import { CountResponse } from '../../../../../../types/api/endpoints/stats/stats.types';
import { STATS_ENDPOINTS } from '../../../../../../utils/api/endpoints/statsEndpoints';

export const DASHBOARD_PUB_LAST_MONTHS_QUERY_KEY = 'DASHBOARD_PUB_LAST_MONTHS';

const PREFIX = '[dashboardPUBLastMonthsQuery]';

export const queryDashboardPUBLastMonths = async () => {
  console.log(PREFIX, `Fetching dashboard PUB last months...`);
  const response = await STATS_ENDPOINTS.dashboardPUBLastMonths();

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received dashboard PUB last months.`);
  return json as CountResponse[];
};
